import React, { useContext, useState } from "react";
import { NotifyContext } from "../../context/notifyContext";
import { Newsletter } from "../../Types/newsletter";
import NewsletterAPI from "../../services/api/newsletterService";
import Button from "../../UI/Button/Button";
import ButtonLoading from "../../UI/Button/ButtonLoading";
import Input from "../../UI/Input/Input";
import TextArea from "../../UI/TextArea/TextArea";

interface AddOrUpdateNewsletterProps {
  onClose: () => void;
  initialState?: Newsletter | null;
}

export default function AddOrUpdateNewsletter({
  onClose,
  initialState,
}: AddOrUpdateNewsletterProps) {
  const notify = useContext(NotifyContext);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: initialState?.title || "",
    content: initialState?.content || "",
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (initialState) {
        await NewsletterAPI.update_newsletter(initialState.id, formData);
        notify("Newsletter mise à jour avec succès", "success");
      } else {
        await NewsletterAPI.create_newsletter(formData);
        notify("Newsletter créée avec succès", "success");
      }
      onClose();
    } catch (error) {
      notify(error, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <Input
        label="Titre"
        value={formData.title}
        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
        required
      />
      <TextArea
        label="Contenu"
        value={formData.content}
        onChange={(e) => setFormData({ ...formData, content: e.target.value })}
        required
        rows={6}
      />
      <div className="flex justify-end gap-2">
        <Button color="error" onClick={onClose}>
          Annuler
        </Button>
        <ButtonLoading
          type="submit"
          loading={loading}
          label={initialState ? "Mettre à jour" : "Créer"}
        />
      </div>
    </form>
  );
} 